import { render, staticRenderFns } from "./e-button-close.vue?vue&type=template&id=5f8071e1&scoped=true&lang=pug&"
import script from "./e-button-close.vue?vue&type=script&lang=js&"
export * from "./e-button-close.vue?vue&type=script&lang=js&"
import style0 from "./e-button-close.vue?vue&type=style&index=0&id=5f8071e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8071e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
